import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const IconSlightCurveDown = (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M2.27735 6.58397C2.04759 6.4308 1.73715 6.49289 1.58397 6.72265C1.4308 6.95241 1.49289 7.26285 1.72265 7.41603L2.27735 6.58397ZM14.2774 7.41603C14.5071 7.26285 14.5692 6.95241 14.416 6.72265C14.2628 6.49289 13.9524 6.4308 13.7226 6.58397L14.2774 7.41603ZM1.72265 7.41603C5.52391 9.9502 10.4761 9.9502 14.2774 7.41603L13.7226 6.58397C10.2573 8.89421 5.74271 8.89421 2.27735 6.58397L1.72265 7.41603Z",
        fill: "black"
    }));

export { IconSlightCurveDown };
